import { rest } from 'msw';
import { COURSE_EXPRESS_API_URL } from 'config/variables';

import {
  conversationMock,
  courseSummaryMock,
} from '../courseCreationAssistant.mock';

const startConversation = rest.get(
  `${COURSE_EXPRESS_API_URL}/course-express`,
  (req, res, ctx) => {
    return res(
      ctx.delay(1000),
      ctx.json({
        data: conversationMock,
      }),
    );
  },
);

const resumeConversation = rest.get(
  `${COURSE_EXPRESS_API_URL}/course-express/:sessionId`,
  (req, res, ctx) => {
    return res(
      ctx.delay(3000),
      ctx.json({
        data: conversationMock,
      }),
    );
  },
);

const sendMessage = rest.post(
  `${COURSE_EXPRESS_API_URL}/course-express/:sessionId/:stepId`,
  (req, res, ctx) => {
    return res(
      // ctx.delay(1000),
      ctx.json({
        data: conversationMock,
      }),
    );
  },
);

const getCourseSummary = rest.post(
  `${COURSE_EXPRESS_API_URL}/course-express/:sessionId/generate/summary`,
  (req, res, ctx) => {
    return res(
      ctx.json({
        data: {
          id: 'e410113a-a639-4897-a055-5f62bc350e3b',
          summary: courseSummaryMock,
        },
      }),
    );
  },
);

const saveCourseSummary = rest.put(
  `${COURSE_EXPRESS_API_URL}/course-express/:sessionId/summary/:summaryId`,
  (req, res, ctx) => {
    return res(
      ctx.delay(1000),
      ctx.json({
        data: 'ok',
      }),
    );
  },
);

export const courseCreationAssistantHandlers = [
  // startConversation,
  // resumeConversation,
  // sendMessage,
  // getCourseSummary,
  // saveCourseSummary,
];
